import type { FC } from 'react';
import { Navigate, Outlet } from 'react-router';

import { ISADMINLOGGED } from '../constants/global';
import { pageurl } from '../constants/pageurl';
import Layout from '../layout';

export interface IRouteProps {
	path?: string | string[] | undefined;
}

const AuthRoute: FC<IRouteProps> = () => {
	if (ISADMINLOGGED()) {
		return <Navigate to={pageurl.OVERVIEW} />;
	}

	return (
		<Layout authRoute>
			<Outlet />
		</Layout>
	);
};

export default AuthRoute;
